import { render } from "./check-tariff-v2.vue?vue&type=template&id=25a676de&scoped=true&ts=true"
import script from "./check-tariff-v2.vue?vue&type=script&lang=ts"
export * from "./check-tariff-v2.vue?vue&type=script&lang=ts"

import "./check-tariff-v2.vue?vue&type=style&index=0&id=25a676de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a676de"]])

export default __exports__